import { ALL_OPTIONS_VALUE, CUSTOM_OPTIONS_VALUE } from './common';
import { USER_PERMISSIONS } from './userPermissions';

export const ORGANISATIONS_STATUSES = {
  ACTIVE: 'Active',
  ARCHIVED: 'Archived',
  DELETED: 'Deleted',
};

export const ORGANISATION_USER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const ORGANISATION_USER_STATUS_LABEL = {
  [ORGANISATION_USER_STATUS.ACTIVE]: 'Active',
  [ORGANISATION_USER_STATUS.INACTIVE]: 'Inactive',
};

export const ORGANISATION_USER_STATUS_DESCRIPTION = {
  [ORGANISATION_USER_STATUS.ACTIVE]:
    'Active users have been part of an active Culture Project or have participated in a Feedback Framework process within the last 3 months.',
  [ORGANISATION_USER_STATUS.INACTIVE]:
    'Inactive users have not been part of an active Culture Project and have not participated in a Feedback Framework process for at least 3 months.',
};

export const ORGANISATION_USER_STATUS_FILTER_VALUES = [
  ALL_OPTIONS_VALUE,
  ORGANISATION_USER_STATUS.ACTIVE,
  ORGANISATION_USER_STATUS.INACTIVE,
];

export const ORGANISATION_USER_TYPE_FILTER_VALUES = [
  ALL_OPTIONS_VALUE,
  USER_PERMISSIONS.USER,
  USER_PERMISSIONS.ORGANISATION_ADMIN,
];

export const INVALID_ACCOUNT_ERROR = {
  title: 'Invalid Account',
  message:
    'It looks like your account has been deactivated. Please reach out to your organisation for further information.',
};

export const ORGANISATION_OVERVIEW_TIMEFRAME_OPTIONS = [
  { value: ALL_OPTIONS_VALUE, label: 'All time' },
  { value: 'last_7_days', label: 'Last 7 days' },
  { value: 'last_30_days', label: 'Last 30 days' },
  { value: CUSTOM_OPTIONS_VALUE, label: 'Custom Date Range' },
];

export const NON_TEST_MODE_ORGANISATIONS_PARAMS = { 'test-mode': false };
